/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { VhatsAppBaseService } from '../vhats-app-base-service';
import { hatsAppApiConfiguration } from '../hats-app-api-configuration';
import { hatsAppStrictHttpResponse } from '../hats-app-strict-http-response';

import { monitorProbeGet } from '../fn/monitor/monitor-probe-get';
import { MonitorProbeGet$Params } from '../fn/monitor/monitor-probe-get';
import { MonitorProbeResultModel } from '../models/monitor-probe-result-model';


/**
 * Controller for system monitoring and health check endpoints. Provides operational oversight and maintenance capabilities.
 */
@Injectable({ providedIn: 'root' })
export class hatsAppMonitorService extends VhatsAppBaseService {
  constructor(config: hatsAppApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitorProbeGet()` */
  static readonly MonitorProbeGetPath = '/Monitor/Probe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorProbeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorProbeGet$Response(params?: MonitorProbeGet$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<MonitorProbeResultModel>> {
    const obs = monitorProbeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorProbeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorProbeGet(params?: MonitorProbeGet$Params, context?: HttpContext): Observable<MonitorProbeResultModel> {
    const resp = this.monitorProbeGet$Response(params, context);
    return resp.pipe(
      map((r: hatsAppStrictHttpResponse<MonitorProbeResultModel>): MonitorProbeResultModel => r.body)
    );
  }

}
